module.exports = __webpack_public_path__ + "img/product-img-1.a37d8ab8.png";